import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";

export const MetaBar = ({ meeting, canWrite, onChange }) => {
  const { L } = useApp();
  const [folders, setFolders] = useState([]);
  const [tag, setTag] = useState("");
  useEffect(() => { api.get("/folders", { params: { workspace_id: meeting.workspace_id } }).then((r) => setFolders(r.data)); }, [meeting.workspace_id]);
  const patch = async (data) => { await api.patch(`/meetings/${meeting.id}`, data); onChange(); };
  const tags = meeting.tags || [];
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="meta-bar">
      {tags.map((t) => (
        <span key={t} className="flex items-center gap-1 rounded-full bg-violet-50 px-2.5 py-1 text-xs font-semibold text-violet-800">#{t}
          {canWrite && <button onClick={() => patch({ tags: tags.filter((x) => x !== t) })} aria-label={`Buang tag ${t}`}><X size={11} /></button>}
        </span>
      ))}
      {canWrite && (
        <form onSubmit={(e) => { e.preventDefault(); if (tag.trim()) { patch({ tags: [...new Set([...tags, tag.trim()])] }); setTag(""); } }}>
          <Input value={tag} onChange={(e) => setTag(e.target.value)} placeholder={L("+ tag", "+ tag")} className="h-7 w-24 rounded-full text-xs" data-testid="add-tag-input" />
        </form>
      )}
      {canWrite && (
        <Select value={meeting.folder_id || "none"} onValueChange={(v) => patch({ folder_id: v === "none" ? "" : v })}>
          <SelectTrigger className="h-7 w-40 rounded-full text-xs" data-testid="move-folder-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="none">{L("Tiada folder", "No folder")}</SelectItem>{folders.map((f) => <SelectItem key={f.id} value={f.id}>{f.name}</SelectItem>)}</SelectContent>
        </Select>
      )}
    </div>
  );
};
